import { useSelector } from "react-redux";
import MovieList from "./MovieList";

const SecondaryContainer = () =>{

    const movies = useSelector(store=>store.movies)

    return (<div className="bg-black w-screen">
        <div className=" mt-0 md:-mt-52 pl-4 md:pl-12 relative z-20">
          <MovieList title={"Now Playing"} movies={movies?.nowPlayingMovies} />
          <MovieList title={"Popular"} movies={movies?.popularMovies} />
          <MovieList title={"Top Rated Movies"} movies={movies?.topRatedMovies} />
          <MovieList title={"Upcoming Movies"} movies={movies?.upcomingMovies}
          />
        </div>
      </div>)
}

export default SecondaryContainer;